import { Image } from '@belong/ui';
import classNames from 'classnames/bind';
import { getHomeListPrice } from 'utils/mapUtils';
import styles from './rented-marker.module.css';

const cx = classNames.bind(styles);
const selectedMarkerSrc = '/icons/map/selected_off_market_home_marker.png';
const markerSrc = '/icons/map/off_market_home_marker.png';

type RentedMarkerProps = {
  isHover: boolean;
  home: any;
  /**
   * `lat`/`lng` are read off this element by `google-map-react` itself to
   * position the marker, so they are part of the contract even though this
   * component never reads them. `isActive` is likewise passed by the map.
   */
  lat: number;
  lng: number;
  isActive: boolean;
};

export function RentedMarker({ isHover, home }: RentedMarkerProps) {
  return (
    <div>
      <div className={cx('rented-marker', { hover: isHover })}>
        <Image
          src={isHover ? selectedMarkerSrc : markerSrc}
          className={cx('listing-icon')}
          alt=""
        />
      </div>
      <div className={cx('recently-off-market-wrapper', { hover: isHover })}>
        Recently <div>Off Market</div>
      </div>
      <div className={cx('rented-text-wrapper', { hover: isHover })}>
        {getHomeListPrice(home.rentAmount)}
      </div>
    </div>
  );
}
